export const STATUSES = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  DONE: "done",
  ERROR: "error",
}

export const TRACKING_EVENTS = {
  OPENED: "ai-summary-opened",
  OPENED_MULTITAB: "ai-summary-multitab-opened",
  VIEWED: "ai-summary-viewed",
  GENERATE: "ai-summary-generate",
  REGENERATE: "ai-summary-regenerate",
  COPY: "ai-summary-copy",
  POPOUT: "ai-summary-pop-out",
  FEEDBACK: "ai-summary-feedback",
  ADDITIONAL_FEEDBACK: "ai-summary-additional-feedback",
  EXTERNAL_LINK_CLICKED: "ai-summary-external-link-clicked",
}

export const ACTIONS = {
  ANALYZE_FACTORS_SUMMARY: "analyze_factors_summary",
  FACTOR_SUMMARY: "factor_summary",
  SECURITY_SUMMARY: "security_summary",
  SIMULATOR_SUMMARY: "simulator_summary",
}
